import LoyaltyClubContent from './LoyaltyClubContent';
import { LoginPopupContentProps } from 'components/Blocks/Popup/Login/LoginContent';
import Webline from 'components/Layout/Webline/Webline';
import { mobileFirstSizes } from 'components/Theme/mediaQueries';
import { useCurrentCart } from 'connectors/cart/Cart';
import { useLoyaltyClubPoints } from 'connectors/loyaltyClub/LoyaltyClub';
import { useCurrentUserData } from 'hooks/user/useCurrentUserData';
import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react';
import { PopupProps } from 'types/popup';

const Popup = dynamic<PopupProps>(() => import('components/Layout/Popup/Popup').then((component) => component.Popup));
const LoginContent = dynamic<LoginPopupContentProps>(() =>
    import('components/Blocks/Popup/Login/LoginContent').then((component) => component.LoginContent),
);

const LoyaltyClub: FC = () => {
    const loyaltyClubInfo = useLoyaltyClubPoints();
    const { isUserLoggedIn } = useCurrentUserData();
    const { cart } = useCurrentCart();
    const [isUserPopupOpened, setIsUserPopupOpened] = useState(false);
    const [isMobileView, setIsMobileView] = useState(false);
    const hasVoucherProduct = !!cart?.hasVoucherProduct;

    useEffect(() => {
        const handler = () => setIsMobileView(window.innerWidth < mobileFirstSizes.vl);
        handler();
        window.addEventListener('resize', handler, { passive: true });

        return () => {
            window.removeEventListener('resize', handler);
        };
    }, []);

    return (
        <>
            <Webline>
                <LoyaltyClubContent
                    loyaltyClubInfo={loyaltyClubInfo}
                    hasVoucherProduct={hasVoucherProduct}
                    setIsUserPopupOpened={setIsUserPopupOpened}
                />
            </Webline>
            {isUserPopupOpened && !isUserLoggedIn && (
                <Popup
                    className="w-screen font-light vl:mt-2 vl:w-3/5 vl:min-w-[936px] vl:rounded-md"
                    onCloseCallback={() => setIsUserPopupOpened(false)}
                >
                    <LoginContent isMobileView={isMobileView} />
                </Popup>
            )}
        </>
    );
};

export default LoyaltyClub;
